import builder from '../builder';
import DressingHanger1 from '../../streamline-icons/bold/dressing-hanger-1.svg';

export default builder('IconDressingHanger1Bold', DressingHanger1);
